const baseUrl = "https://api.openweathermap.org";
const apiKey = "0698c2355ad42660adf01478915d1ce3";
const targetCityName = "Lviv";
const countryCode = "UA";
const lattitude = 49.8383;
const longitude = 24.0232;
const units = "metric";

export const getWeather = () => {
    const filters = new URLSearchParams();

    filters.append("q", targetCityName);
    filters.append("appid", apiKey);
    filters.append("units", units);

    const filtersString = filters.toString();

    return fetch(
        `${baseUrl}/data/2.5/weather${
            filtersString ? "?" + filtersString : ""
        }`,
    )
        .then((response) => response.json())
        .catch((error) => String(error));
};

export const getHistoricalWeather = (date) => {
    const filters = new URLSearchParams();

    filters.append("lat", lattitude);
    filters.append("lon", longitude);
    filters.append("dt", Math.round(date.getTime() / 1000));
    filters.append("appid", apiKey);
    filters.append("units", units);
    filters.append("lang", "ua");

    const filtersString = filters.toString();

    return fetch(
        `${baseUrl}/data/2.5/onecall/timemachine${
            filtersString ? "?" + filtersString : ""
        }`,
    )
        .then((response) => response.json())
        .catch((error) => String(error));
};
